import type { ResolutionsData } from '@library/types/resolutions/resolutionsList';
import type { ResolutionsDetails } from '@library/types/resolutions/resolutionDetails';
import { formatDate } from '@library/component-utils/dateTime';

export const transformAllResolutions = ({
  page,
  perPage,
  response
}: {
  page: number;
  perPage: number;
  response: ResolutionsDetails | undefined;
}): ResolutionsData => {
  if (!response) {
    return {
      currentPage: 0,
      data: [],
      totalPages: 0
    };
  }

  const extractAllResolutionData = (data: ResolutionsDetails) => {
    const included = data.included ?? [];

    const admins = included
      .filter((inc) => inc.type === 'admin_user')
      .map((admin) => ({
        id: admin.id,
        fullName: `${admin.attributes.first_name} ${admin.attributes.last_name}`
      }));

    return data.data.map((entry) => {
      const {
        id,
        attributes: {
          created_at: createdAt,
          resolution_type: resolutionType,
          status,
          updated_at: updatedAt
        },
        relationships
      } = entry;
      const createdById = relationships?.created_by?.data?.id;
      const reasonId = relationships?.reason?.data?.id;
      const createdBy = included.find(
        (inc) => inc.id === createdById && inc.type === 'admin_user'
      );
      const reason = included.find(
        (inc) => inc.id === reasonId && inc.type === 'reason'
      );
      const createdAtTime = formatDate({
        date: createdAt,
        pattern: 'hh:mm a'
      });
      const createdAtDate = formatDate({
        date: createdAt,
        pattern: 'MMMM d, yyyy'
      });
      const updatedAtTime = formatDate({
        date: updatedAt,
        pattern: 'hh:mm a'
      });
      const updatedAtDate = formatDate({
        date: updatedAt,
        pattern: 'MMMM d, yyyy'
      });

      return {
        admins,
        adminEmail: createdBy?.attributes.email ?? '',
        adminName: `${createdBy?.attributes.first_name} ${createdBy?.attributes.last_name}`,
        createdAtDate,
        createdAtTime,
        createdById,
        reason: reason?.attributes.description ?? '',
        id,
        type: resolutionType,
        status,
        updatedAtDate,
        updatedAtTime
      };
    });
  };

  const allResolutions = extractAllResolutionData(response);

  const totalPages = allResolutions.length < perPage ? page : page + 1;

  return {
    currentPage: page,
    data: allResolutions,
    totalPages
  };
};
